import Axios from 'axios'

let currentRequestSource

const cancelPreviousRequest = () => {
  if (currentRequestSource) {
    currentRequestSource.cancel()
  }
}

const createCancelToken = () => {
  currentRequestSource = Axios.CancelToken.source()
  return currentRequestSource.token
}

const fetchLocationAutocomplete = async ({ query, limit = 4 }) => {
  cancelPreviousRequest()

  const cancelToken = createCancelToken()

  try {
    const { status, data } = await Axios.post(
      '/api/locationAutocomplete',
      { query, limit },
      { cancelToken }
    )

    return status === 200 ? data : []
  } catch (error) {
    return []
  } finally {
    currentRequestSource = null
  }
}

export default fetchLocationAutocomplete
